
import * as React from 'react';
import { UIComponentViewImpl } from '../uicomponentview';
import { HorizontalListComponentProps } from './horizontallistcomponent';
import { HorizontalListCSSStyle } from './horizontallistcss';
import { GenericHorizontalListComponent } from './generichorizontallist/genericlistcomponent';
import { UIComponentState } from '../uicomponent';


export class HorizontalListViewImpl<T> extends UIComponentViewImpl<T>
{
    draw(props: HorizontalListComponentProps<T>, state: UIComponentState, cssStyle: HorizontalListCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

       return (
            <GenericHorizontalListComponent length={props.listViewModel.getListOfDatas().length} arrowsType={props.arrowsType} isLoadMoreRequired={false} arrowsPaddingType={props.arrowsPaddingType} arrowsSizeType={props.arrowsSizeType} gutterMargin={props.gutterType} titleCSSStyle={props.listViewModel.getTitleCSSStyle()} title={props.title} onScrollEnd={() => {}} arrowMarginTop={props.marginTopType} context={props.context}>
            {props.listViewModel.getListOfDatas().map((t: T, index: number)=> 
                {
                    return props.listViewModel.getView(t, index);
                }
            )}
            </GenericHorizontalListComponent>
       );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/horizontallist/horizontallistview.tsx